<template>
  <div id="chart">
    <v-row class="mx-0 px-0 pt-3">
      <h3 class="ml-2">Total Produtos vencidos: {{ Helpers.formatarValor(total.vencido) }}</h3>

      <v-spacer></v-spacer>

      <span class="descricao-cor vermelho"></span> Vencidos
      <span class="descricao-cor azul ml-12"></span> A vencer

      <v-spacer></v-spacer>

      <h3 class="mr-2">Total Produtos dentro do prazo: {{ Helpers.formatarValor(total.naoVencido) }}</h3>
    </v-row>

    <apexchart
      v-click-labels-chart="labelDataPointSelecionado"
      type="bar"
      height="265"
      :options="optionsComputed"
      :series="series"
    ></apexchart>

    <v-data-table
      :headers="headers"
      :items="desserts"
      :search="search"
      height="calc(100vh - 400px)"
      :sort-by="['dtvalidade', 'qtde']"
      fixed-header
      class="elevation-2 mt-n3 font-resp-tabela table-full-screen"
      :items-per-page="-1"
      hide-default-footer
      dense
      :loading="loadingTabela"
    >
      <template v-slot:progress>
        <v-progress-linear
          indeterminate
          color="error"
          class="mt-n1"
        ></v-progress-linear>
      </template>

      <template v-slot:item.qtde="{item}">
        {{ Helpers.formatarValor(item.qtde)}}
      </template>

      <template v-slot:top>
        <v-toolbar flat color="white" style="border: 1px solid red" height="40px">
          <h4 class="ml-n3">Listagem de Lotes</h4>
          <v-spacer></v-spacer>

          <v-text-field
            v-model="search"
            append-icon="mdi-magnify"
            label="Pesquisar"
            single-line
            dense
            hide-details
            clearable
            style="max-width: 450px"
          ></v-text-field>
          <v-btn
            dark
            small
            class="ml-4"
            color="primary"
            @click="!loadingTabela && clickTableValidadeLote()"
          >Ver Todos os Lotes</v-btn>
        </v-toolbar>
      </template>
    </v-data-table>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import CompraAPI from "./../../api/compra";

export default {
  data: () => ({
    loadingTabela: false,
    series: [
      {
        name: "Quantidade do Lote",
        data: [],
      },
    ],
    options: {
      grid: {
        show: true,
        position: "back",
        yaxis: {
          lines: {
            show: true,
          },
        },
        xaxis: {
          lines: {
            show: true,
          },
        },
      },
      colors: [],
      plotOptions: {
        bar: {
          columnWidth: "50%",
          distributed: true,
          dataLabels: {
            position: "top",
          },
        },
      },
      dataLabels: {
        enabled: true,
        offsetY: -18,
        style: {
          colors: ["#000"],
        },
        formatter: function (value) {
          return new Intl.NumberFormat("pt-BR", {
            style: "decimal",
            maxDigits: 4,
          }).format(value);
        },
      },
      legend: {
        show: false
      },
      xaxis: {
        categories: [],
        labels: {
          show: true,
          style: {
            colors: [],
            fontSize: "12px",
          },
        },
      },
      yaxis: {
        labels: {
          formatter: function (value) {
            return new Intl.NumberFormat("pt-BR", {
              style: "decimal",
              maxDigits: 4,
            }).format(value);
          },
        },
      },
    },

    total: {
      vencido: 0,
      naoVencido: 0
    },
    search: '',
    headers: [
      { text: 'Nº Lote', value: 'numlote' },
      { text: 'Quantidade', value: 'qtde' },
      { text: 'Validade', value: 'dtvalidade' },
    ],
    desserts: [],
    dataProdutoLotes: ""
  }),

  computed: {
    ...mapGetters({
      detalhesProduto: "detalhe_produto/getProduto",
      grupoCompra: "usuario/getGrupoCompras",
      filialCompra: "usuario/getFilialCompras",
    }),
    optionsComputed () {
      let opts = this.options;

      opts.chart = {
        toolbar: {
          show: false
        },
        events: {
          dataPointSelection: (event, chartContext, config) => {
            this.clickTableValidadeLote(config.w.globals.labels[config.dataPointIndex]);
          },
        }
      }

      return opts;
    }
  },

  created() {
    this.dadosGrafico();
    this.clickTableValidadeLote();
  },
  methods: {
    labelDataPointSelecionado (evtData) {
      const {data} = evtData.target.firstChild;

      this.clickTableValidadeLote(data);
    },
    clickTableValidadeLote(dataLabel) {
      this.loadingTabela = true
      this.desserts = []

      const headers = this.Helpers.iniciarRequisicao();

      const params = {
        idproduto: this.detalhesProduto.idproduto,
        grupo: this.detalhesProduto.id_grupo,
        filial: this.filialCompra,
        data_label: dataLabel
      };

      CompraAPI.getProdutoValidadesTodosLotes(headers, params)
        .then((response) => {
          const token = response.data.token;
          localStorage.setItem("token", token);

          this.desserts = response.data.produto_lotes;
          this.loadingTabela = false
        })
        .catch(() => {
          this.Helpers.logout();
        })
    },
    renderGrafico(lotes) {
      let categories = [];

      lotes.forEach((item) => {
        if (item.vencido) {
          this.total.vencido += parseFloat(item.qtde);
          this.options.colors.push("#D60E2B");
        } else {
          this.total.naoVencido += parseFloat(item.qtde);
          this.options.colors.push("#043554");
        }

        categories.push(item.dtvalidade);
        this.series[0].data.push(item.qtde);
      });

      this.options = {
        xaxis: {
          categories: categories,
          labels: {
            style: {
              colors: this.options.colors,
            },
          },
        },
      };
    },

    dadosGrafico() {
      const headers = this.Helpers.iniciarRequisicao();

      const params = {
        grupo: this.grupoCompra,
        filial: this.filialCompra,
        produto: this.detalhesProduto.idproduto,
      };

      this.$store.dispatch(
        "loading/addRequisicao",
        CompraAPI.getValidadesLotes(headers, params)
          .then((response) => {
            const token = response.data.token;
            localStorage.setItem("token", token);

            this.renderGrafico(response.data.lotes);
          })
          .catch(() => {
            this.Helpers.logout();
          })
      );
    }
  },
};
</script>

<style scoped>
.descricao-cor {
  padding-left: 18px;
  margin-right: 5px;
  margin-left: 19px;
  height: 18px;
}
.vermelho {
  background: #D60E2B;
}
.azul {
  background: #043554;
}
</style>
